import { http } from '../plugins/http'
import DataResponse from '@/types/DataResponse'
import AdditionalField from '@/types/AdditionalField'

export default class AdditionalFieldService {
  async index(configurationId: string) {
    return await http.get<DataResponse<AdditionalField[]>>(`/api/v1/office/event-configurations/${configurationId}/additional-fields`)
  }

  async store(model: AdditionalField) {
    return await http.post<AdditionalField>(`/api/v1/office/additional-fields`, model)
  }

  async update(model: AdditionalField) {
    return await http.put<AdditionalField>(`/api/v1/office/additional-fields/${model.id}`, model)
  }

  async destroy(id: string) {
    return await http.delete(`/api/v1/office/additional-fields/${id}`)
  }

  async updateSortingOrder(fields: AdditionalField[]) {
    return await http.put(`/api/v1/office/additional-fields/sorting`, { additional_fields: fields })
  }
}
